import React, { useEffect, useMemo } from "react";
import StorageKeys from "../config/constants/storage";
import { v4 as uuidv4 } from "uuid";

const UserAgents = {
  "Generic Linux": /Linux/i,
  Android: /Android/i,
  BlackBerry: /BlackBerry/i,
  Bluebird: /EF500/i,
  "Chrome OS": /CrOS/i,
  Datalogic: /DL-AXIS/i,
  Honeywell: /CT50/i,
  iPad: /iPad/i,
  iPhone: /iPhone/i,
  iPod: /iPod/i,
  macOS: /Macintosh/i,
  Windows: /IEMobile|Windows/i,
  Zebra: /TC70|TC55/i,
};

const useDeviceId = () => {
  const [deviceId, handleDeviceId] = React.useState(
    localStorage.getItem(StorageKeys.deviceId)
  );

  const device = useMemo(() => {
    for (let ua in UserAgents) {
      if (navigator.userAgent.match(UserAgents[ua])) return ua;
    }
  }, []);

  const setDeviceId = (id) => {
    localStorage.setItem(StorageKeys.deviceId, id);
    handleDeviceId(id);
  };

  useEffect(() => {
    if (!deviceId) {
      setDeviceId(uuidv4());
    }
  }, []);

  return {
    deviceId,
    device,
    platform: navigator.platform,
    vendor: navigator.userAgent,
  };
};

export default useDeviceId;
